export const BaseUrl = 'https://api.mindreset.app'
